import React, { useState } from 'react';
import { IDevice } from '../../interfaces';

export const ModalManualSelection = (props: {
    availableDevices: IDevice[];
    selectedDevices: Set<number>;
    onAdd: (id: number) => void;
    onRemove: (id: number) => void;
    close: () => void;
}) => {
    const [state, setState] = useState({
        closing: false
    });

    return (
        <div
            className={`modal-background${state.closing ? ' closing' : ''}`}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    setState({
                        ...state,
                        closing: true
                    });

                    setTimeout(props.close, 200);
                }
            }}
        >
            <div className="modal">
                <div className="flex-conflicts">
                    <h6>Ecrans</h6>
                    <div className="flex-conflicts-col">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Magasin</th>
                                    <th>Ville</th>
                                    <th>Zip</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.availableDevices.map((d) => (
                                    <tr key={d.id}>
                                        <td>{d.id}</td>
                                        <td>{d.Shop.name}</td>
                                        <td>{d.Shop.city}</td>
                                        <td>{d.Shop.zip}</td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={props.selectedDevices.has(d.id)}
                                                onChange={() => {
                                                    if (props.selectedDevices.has(d.id)) {
                                                        props.onRemove(d.id);
                                                    } else {
                                                        props.onAdd(d.id);
                                                    }
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
